import React, { useCallback } from 'react';
import { TextField } from '../TextField/TextField';
import type { TextFieldProps } from '../TextField/TextField.types';

export const NumberField = (props: NumberFieldProps) => {
  const { keyboardType = 'numeric', value, defaultValue, ...restProps } = props;

  // ────────────────────────────────────────────────────────────────────────────────

  const validateTextAsNumber = useCallback((text: string) => {
    const textAsNumber = Number(text);
    const containsOnlyNumericChars = Number.isFinite(textAsNumber);
    const hasWhitespace = /\s/g.test(text);
    const startsWithNegate = text.length === 1 && text.startsWith('-');
    const isValidValue =
      !hasWhitespace && (startsWithNegate || containsOnlyNumericChars);

    return isValidValue;
  }, []);

  // ────────────────────────────────────────────────────────────────────────────────

  const convertedValue =
    typeof value !== 'undefined' ? String(value) : undefined;
  const convertedDefaultValue =
    typeof defaultValue !== 'undefined' ? String(defaultValue) : undefined;

  return (
    <TextField
      keyboardType={keyboardType}
      value={convertedValue}
      defaultValue={convertedDefaultValue}
      onChangeTextGuard={validateTextAsNumber}
      {...restProps}
    />
  );
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type NumberFieldProps = Omit<
  TextFieldProps,
  'keyboardType' | 'value' | 'defaultValue' | 'onChangeTextGuard'
> & {
  readonly keyboardType?: 'number-pad' | 'decimal-pad' | 'numeric';
  readonly value?: number;
  readonly defaultValue?: number;
};
